import { useSelector } from "react-redux";
import imacEnergyDashboardImage from "../../../assets/smartbuilding/screensSection/imacEnergyDashboard.png";
import plateformedjuImage from "../../../assets/smartbuilding/screensSection/plateforme-dju.png";
import plateformeautomatismeImage from "../../../assets/smartbuilding/screensSection/plateforme-automatisme.png";
import parkingOn from "../../../assets/smartbuilding/screensSection/eclairage-public.png";
import lightOff from "../../../assets/smartbuilding/screensSection/ampouleOff.png";
import radiatorOn from "../../../assets/smartbuilding/screensSection/radiatorOn.png";
import radiatorOff from "../../../assets/smartbuilding/screensSection/radiatorOff.png";

export default function ScreenSection(props) {
  const { textContent, language } = { ...props };

  const isMobile = useSelector((state) => state.screen.isMobile);

  const items = [
    {
      icon: radiatorOn,
      text: textContent?.sreenSection?.screens?.automatismes?.example.one[
        language
      ],
    },
    {
      icon: radiatorOff,
      text: textContent?.sreenSection?.screens?.automatismes?.example.two[
        language
      ],
    },
    {
      icon: lightOff,
      text: textContent?.sreenSection?.screens?.automatismes?.example.three[
        language
      ],
    },
    {
      icon: parkingOn,
      text: textContent?.sreenSection?.screens?.automatismes?.example.four[
        language
      ],
    },
  ];

  return (
    <section className="container">
      <div className="screen1">
        <div className="screen1-width">
          <div className="screen1-legend">
            <div className="screen1-legend-unit">
              <p className="h3-bold">
                {
                  textContent?.sreenSection?.screens?.energyDashboard
                    ?.description1[language]
                }
              </p>
            </div>
            <div className="screen1-legend-unit">
              <p className="h3-bold">
                {
                  textContent?.sreenSection?.screens?.energyDashboard
                    ?.description2[language]
                }
              </p>
            </div>
          </div>
          <div className="screen1Image">
            <img src={imacEnergyDashboardImage} aria-hidden="true" />
          </div>
        </div>
      </div>
      <div className="container-empty-small" />
      <div className="screen2">
        <div>
          <h2 className="h2-bold">
            {textContent?.sreenSection?.screens?.dju?.title[language]}
          </h2>
          <h3>{textContent?.sreenSection?.screens?.dju?.subtitle[language]}</h3>
        </div>
        <div className="screen2Image">
          <img src={plateformedjuImage} aria-hidden="true" />
          <div className="screen2OverlayBox">
            <p
              dangerouslySetInnerHTML={{
                __html:
                  textContent?.sreenSection?.screens?.dju?.description1[
                    language
                  ],
              }}
            />
          </div>
        </div>
      </div>
      {isMobile ? (
        <div className="container-empty-small" />
      ) : (
        <div className="container-empty-medium" />
      )}

      <div className="screen3">
        <div className="screen3-text">
          <h2 className="h2-bold">
            {textContent?.sreenSection?.screens?.automatismes?.title[language]}
          </h2>
          <h3>
            {
              textContent?.sreenSection?.screens?.automatismes?.subtitle[
                language
              ]
            }
          </h3>
          <h2 className="h2-bold">
            {textContent?.sreenSection?.screens?.notifications?.title[language]}
          </h2>
          <h3>
            {
              textContent?.sreenSection?.screens?.notifications?.subtitle[
                language
              ]
            }
          </h3>
        </div>
        <div className="screen3Image">
          <img src={plateformeautomatismeImage} aria-hidden="true" />
          <div className="screen3OverlayBox">
            <div className="alc" role="list" aria-label="Automatismes">
              {items.map((it, idx) => (
                <div
                  className="alc__row"
                  role="listitem"
                  key={`${it.text}-${idx}`}
                >
                  <div className="alc__iconWrap" aria-hidden="true">
                    <img className="alc__icon" src={it.icon} alt="" />
                  </div>

                  <div className="alc__text">{it.text}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="container-empty-medium" />
    </section>
  );
}
